export const PROJECT_ROOT_ROUTE_ID = 'Project';
export const PROJECT_ROOT_ROUTE_NAME = '::Menu:Flows';

export const VIRTUAL_AGENT_ROOT_ROUTE_ID = 'VirtualAgent';
export const VIRTUAL_AGENT_ROOT_ROUTE_NAME = '::Menu:VirtualAgent';
export const VIRTUAL_AGENTS_ROOT_ROUTE_NAME = '::Menu:VirtualAgents';

export const AI_AGENT_ROOT_ROUTE_ID = 'AiAgent';
export const AI_AGENT_ROOT_ROUTE_NAME = '::Menu:AiAgents';

export const GUARDRAIL_ROOT_ROUTE_ID = 'Guardrail';
export const GUARDRAIL_ROOT_ROUTE_NAME = '::Menu:Guardrails';

export const KNOWLEDGE_BASE_ROOT_ROUTE_ID = 'KnowledgeBase';
export const KNOWLEDGE_BASE_ROOT_ROUTE_NAME = '::Menu:KnowledgeBases';

export const RESPONSE_MANAGEMENT_ROUTE_ID = 'ResponseManagement';
export const RESPONSE_MANAGEMENT_ROUTE_NAME = 'Project::ResponseManagement:ResponseEditor';

export const PROMPTS_ROOT_ROUTE_ID = 'Prompts';
export const PROMPTS_ROOT_ROUTE_NAME = 'Project::Prompts';

export const SYSTEM_MESSAGES_ROUTE_ID = 'SystemMessages';
export const SYSTEM_MESSAGES_ROUTE_NAME = 'Project::SystemMessages';

export const DASHBOARD_ROUTE_ID = 'Dashboard';
export const DASHBOARD_ROUTE_NAME = '::Menu:Dashboard';

export const INSIGHTS_ROOT_ROUTE_ID = 'Insights';
export const INSIGHTS_ROOT_ROUTE_NAME = 'Project::Insights';

export const CONVERSATIONS_ROUTE_ID = 'Conversations';
export const CONVERSATIONS_ROUTE_NAME = '::Menu:Conversations';

export const GENERATIVE_QUESTION_ANSWERING_RECOGNITIONS_ROUTE_ID = 'GenerativeQnaReporting';
export const GENERATIVE_QUESTION_ANSWERING_RECOGNITIONS_ROUTE_NAME =
  '::Menu:GenerativeQnaReporting';

export const OUTBOUND_ROUTE_ID = 'Outbound';
export const OUTBOUND_ROUTE_NAME = '::Menu:Outbound';

export const PREMIUM_REPORTING_ROUTE_NAME = 'PremiumReporting::Menu:PremiumReports';

export const SUBFLOW_TYPE_NAME = 'SubFlow';
export const CREATE_SUBFLOW_ROUTE_ID = 'Create' + SUBFLOW_TYPE_NAME;
export const CREATE_SUBFLOW_ROUTE_NAME = '+ ' + SUBFLOW_TYPE_NAME;

export const PROJECTS_PATH = 'projects';
export const VERSIONS_PATH = 'versions';
export const SCENARIO_DESIGN_PATH = 'scenario-design';
export const VIRTUAL_AGENTS_PATH = 'virtual-agents';
export const AI_AGENTS_PATH = 'ai-agents';
export const GUARDRAILS_PATH = 'guardrails';
export const KNOWLEDGE_BASES_PATH = 'knowledge-bases';
export const INTENTS_PATH = 'intents';
export const EDIT_PATH = 'edit';
export const ADD_PATH = 'add';
export const DASHBOARD_PATH = 'dashboard';
export const CONVERSATIONS_PATH = 'conversations';
export const GENERATIVE_QUESTION_ANSWERING_RECOGNITIONS_PATH =
  'generative-question-answering-recognitions';
export const OUTBOUND_PATH = 'outbound';
export const INSIGHTS_PREFIX_PATH = 'insights';
export const PROMPTS_PREFIX_PATH = 'prompts';
export const RESPONSE_MANAGEMENT_PATH = 'prompts/response-management';
export const SYSTEM_MESSAGES_PATH = 'prompts/system-messages';
export const PREMIUM_REPORTING_PATH = 'premium-reporting';
export const NOTIFICATIONS_PATH = 'notifications';
export const SESSIONS_PATH = 'sessions';
export const CUSTOM_DATA_PATH = 'custom-data';
export const OUTBOUND_RULES_PATH = 'outbound-rules';
